module.exports = __webpack_public_path__ + "static/media/R2.7f94f593.svg";